import { Dialog } from "@mui/material";
import { Button } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { Input } from "@vds/inputs";
import { Loader } from "@vds/loaders";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { ReactComponent as CloseButton } from "../../assets/closeButton.svg";
import { ReactComponent as WarningIcon } from "../../assets/warning.svg";
import {
  AddUserToGroupCommonTable,
  CreateGroupCommonTable,
  UserGroupsCommonTable,
  ViewUserGroupsCommonTable,
} from "../../global/components/Tables/commonTables";
import { DELETE_GROUP_MODAL_CONSTANTS, MODAL_TEXT, TABLE_COLUMNS, USER_GROUP_DETAILS_CONSTANTS } from "../../global/constants/constants";
import "./UserGroupsModals.css";

export const UserViewTableModal = (props) => {
  const { showUserInfo, setShowUserInfo, userInfo } = props;
  return (
    <Modal
      opened={showUserInfo?.isOpen}
      disableOutsideClick={true}
      ariaLabel="Notifcation group User table  Modal"
      surface="light"
      fullScreenDialog={false}
      hideCloseButton={true}
      disableAnimation={false}
      maxWidth={"md"}
    >
      <ModalTitle>
        <Title size="large">{USER_GROUP_DETAILS_CONSTANTS.MODAL_USER_INFO_TITLE}</Title>
      </ModalTitle>
      <div
        className="modal-close-icon-button"
        data-testid="userViewTableModal_closeIcon"
        onClick={(e) => {
          setShowUserInfo({ isOpen: false });
        }}
      >
        <Icon name="close" />
      </div>
      <ModalBody>
        <div className="modal-body-full-width">
          <UserGroupsCommonTable
            dataList={[...userInfo]}
            pagination={false}
            className="modal-table-wrapper"
            scroll={{
              y: 210,
            }}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export const CreateGroupModal = (props) => {
  const {
    showCreateGroup,
    setShowCreateGroup,
    handleGroupInputChange,
    groupFormFields,
    defaultGroupFormFields,
    setGroupFormFields,
    notificationUsersList,
    onSubmit,
  } = props;
  return (
    <Dialog
      open={showCreateGroup?.isOpen}
      aria-label="Create group Modal"
      fullWidth={true}
      maxWidth={"lg"}
    >
      <div className="modal-inner-wrapper">
        <ModalTitle>
          <Title size="large">
            {showCreateGroup?.isGroupLink
              ? USER_GROUP_DETAILS_CONSTANTS.MODAL_GROUP_INFO_TITLE
              : showCreateGroup?.mode
              ? USER_GROUP_DETAILS_CONSTANTS.MODAL_EDIT_GROUP_TITLE
              : USER_GROUP_DETAILS_CONSTANTS.MODAL_CREATE_GROUP_TITLE}
          </Title>
        </ModalTitle>
        <div
          className="modal-close-icon-button"
          data-testid="createGroupsModal_closeIcon"
          onClick={(e) => {
            setShowCreateGroup({ isOpen: false });
            setGroupFormFields(defaultGroupFormFields);
          }}
        >
          <Icon name="close" />
        </div>
        <ModalBody>
          <div
            className="sasp_d-flex sasp_justify-content-between modal-two-col-layout"
          >
            <div className="modal-col-primary">
              <div className="modal-field-row">
                <Input
                  label={USER_GROUP_DETAILS_CONSTANTS.MODAL_GROUP_NAME_LABEL}
                  required={true}
                  readOnly={showCreateGroup?.isGroupLink}
                  disabled={false}
                  name="name"
                  value={groupFormFields?.name}
                  onChange={handleGroupInputChange}
                  className="sasp_user-group-dropdown"
                  errorText={USER_GROUP_DETAILS_CONSTANTS.MODAL_GROUP_NAME_ERROR}
                />
              </div>
              <div className="modal-field-row">
                <Input
                  label={USER_GROUP_DETAILS_CONSTANTS.MODAL_GROUP_DESCRIPTION_LABEL}
                  required={true}
                  readOnly={showCreateGroup?.isGroupLink}
                  disabled={false}
                  error={false}
                  name="description"
                  value={groupFormFields?.description}
                  onChange={handleGroupInputChange}
                  errorText={USER_GROUP_DETAILS_CONSTANTS.MODAL_GROUP_DESCRIPTION_ERROR}
                />
              </div>
              <div className="modal-field-row">
                <Input
                  label={USER_GROUP_DETAILS_CONSTANTS.MODAL_GROUP_EMAIL_LABEL}
                  readOnly={showCreateGroup?.isGroupLink}
                  required={false}
                  disabled={false}
                  error={false}
                  name="groupemail"
                  value={groupFormFields?.groupemail}
                  onChange={handleGroupInputChange}
                  errorText={USER_GROUP_DETAILS_CONSTANTS.MODAL_GROUP_EMAIL_ERROR}
                />
              </div>
            </div>
            <div className="modal-col-secondary">
              <Title size="medium">
                {TABLE_COLUMNS.USERS} ({groupFormFields?.users?.length})
              </Title>
              <CreateGroupCommonTable
                isGroupLink={showCreateGroup?.isGroupLink}
                groupUsers={[...groupFormFields?.users]}
                handleGroupInputChange={handleGroupInputChange}
                dataList={
                  showCreateGroup?.isGroupLink
                    ? [...groupFormFields?.users]
                    : [...notificationUsersList]
                }
                pagination={false}
                scroll={{
                  y: 210,
                }}
                className="modal-table-wrapper"
              />
            </div>
          </div>
        </ModalBody>
        {!showCreateGroup?.isGroupLink && (
          <ModalFooter
            buttonData={{
              primary: {
                width: "150px",
                disabled:
                  !groupFormFields?.description?.trim() ||
                  !groupFormFields?.name?.trim(),
                children: !showCreateGroup?.mode
                  ? USER_GROUP_DETAILS_CONSTANTS.BUTTON_SUBMIT
                  : USER_GROUP_DETAILS_CONSTANTS.BUTTON_UPDATE,
                "data-testid": "createGroupsModal_submitOrUpdateButton",
                onClick: () => {
                  onSubmit(showCreateGroup?.mode);
                },
              },
            }}
          />
        )}
      </div>
    </Dialog>
  );
};

export const CreateUserModal = (props) => {
  const {
    showCreateUser,
    userFormFields,
    setUserFormFields,
    defaultUserFormFields,
    handleUserFieldChange,
    handleAddOrRemoveGroupCheckBoxChange,
    setShowCreateUser,
    notificationGroupList,
    currentUserGroups,
    onSubmit,
  } = props;
  return (
    <>
      <Dialog
        open={showCreateUser?.isOpen}
        aria-label="Create user Modal"
        fullWidth={true}
        maxWidth={"lg"}
      >
        <div className="modal-inner-wrapper">
          <ModalTitle>
            <Title size="large">
              {showCreateUser?.isUserLink
                ? USER_GROUP_DETAILS_CONSTANTS.MODAL_USER_INFO_TITLE
                : showCreateUser?.mode
                ? USER_GROUP_DETAILS_CONSTANTS.MODAL_EDIT_USER_TITLE
                : USER_GROUP_DETAILS_CONSTANTS.MODAL_CREATE_USER_TITLE}
            </Title>
          </ModalTitle>
          <div
            className="modal-close-icon-button"
            data-testid="createusersModal_closeIcon"
            onClick={() => {
              setShowCreateUser({ isOpen: false });
              setUserFormFields(defaultUserFormFields);
            }}
          >
            <Icon name="close" />
          </div>
          <ModalBody>
            <div
              className="sasp_d-flex sasp-justify-content-between modal-two-col-layout"
            >
              <div className="modal-col-primary">
                <div className="modal-field-row">
                  <Input
                    label={USER_GROUP_DETAILS_CONSTANTS.MODAL_FIRST_NAME_LABEL}
                    readOnly={showCreateUser?.isUserLink}
                    required={true}
                    disabled={false}
                    error={false}
                    name="firstName"
                    value={userFormFields.firstName}
                    onChange={handleUserFieldChange}
                    errorText={USER_GROUP_DETAILS_CONSTANTS.MODAL_FIRST_NAME_ERROR}
                    className="sasp_create-edit-rule-dropdown"
                  />
                </div>
                <div className="modal-field-row">
                  <Input
                    label={USER_GROUP_DETAILS_CONSTANTS.MODAL_LAST_NAME_LABEL}
                    readOnly={showCreateUser?.isUserLink}
                    required={true}
                    disabled={false}
                    error={false}
                    name="lastName"
                    value={userFormFields.lastName}
                    onChange={handleUserFieldChange}
                    className="sasp_create-edit-rule-dropdown"
                    errorText={USER_GROUP_DETAILS_CONSTANTS.MODAL_LAST_NAME_ERROR}
                  />
                </div>
                <div className="modal-field-row">
                  <Input
                    label={USER_GROUP_DETAILS_CONSTANTS.MODAL_CONTACT_NUMBER_LABEL}
                    readOnly={showCreateUser?.isUserLink}
                    required={true}
                    disabled={false}
                    error={false}
                    name="contactNumber"
                    value={userFormFields.contactNumber}
                    onChange={handleUserFieldChange}
                    errorText={USER_GROUP_DETAILS_CONSTANTS.MODAL_CONTACT_NUMBER_ERROR}
                    className="sasp_create-edit-rule-dropdown"
                  />
                </div>
                <div className="modal-field-row">
                  <Input
                    label={USER_GROUP_DETAILS_CONSTANTS.MODAL_EMAIL_ID_LABEL}
                    readOnly={showCreateUser?.isUserLink}
                    required={true}
                    disabled={false}
                    error={false}
                    name="emailID"
                    value={userFormFields.emailID}
                    onChange={handleUserFieldChange}
                    className="sasp_create-edit-rule-dropdown"
                    errorText={USER_GROUP_DETAILS_CONSTANTS.MODAL_EMAIL_ID_ERROR}
                  />
                </div>
              </div>
              <div className="modal-col-secondary-md">
                <Title size="medium">
                  {USER_GROUP_DETAILS_CONSTANTS.COLUMN_GROUPS} ({userFormFields?.selectedUserGroups?.length})
                </Title>
                <ViewUserGroupsCommonTable
                  dataList={
                    showCreateUser?.isUserLink
                      ? [...userFormFields?.selectedUserGroups]
                      : [...notificationGroupList]
                  }
                  currentUserGroups={[...userFormFields?.selectedUserGroups]}
                  handleAddOrRemoveGroupCheckBoxChange={handleUserFieldChange}
                  hasCheckBox={!showCreateUser?.isUserLink}
                  pagination={false}
                  scroll={{
                    y: 210,
                  }}
                  className="modal-table-wrapper"
                />
              </div>
            </div>
          </ModalBody>
          {!showCreateUser?.isUserLink && (
            <ModalFooter
              buttonData={{
                primary: {
                  width: "150px",
                  disabled:
                    !userFormFields?.firstName?.trim() ||
                    !userFormFields?.lastName?.trim() ||
                    !userFormFields?.contactNumber?.trim() ||
                    !userFormFields?.emailID?.trim(),
                  children: !showCreateUser?.mode
                    ? USER_GROUP_DETAILS_CONSTANTS.BUTTON_SUBMIT
                    : USER_GROUP_DETAILS_CONSTANTS.BUTTON_UPDATE,
                  "data-testid": "createUsersModal_submitOrUpdateButton",
                  onClick: () => {
                    onSubmit(showCreateUser?.mode);
                  },
                },
              }}
            />
          )}
        </div>
      </Dialog>
    </>
  );
};

//not being used
export const AddUserToGroupModal = (props) => {
  const {
    showAddToGroup,
    setShowAddToGroup,
    setGroupFormFields,
    defaultGroupFormFields,
    notificationGroupList,
    onAddUser,
    handleAddGroupCheckBoxChange,
    getValidUsersIdToAddGroup,
    addToGroupId,
  } = props;
  return (
    <>
      <Dialog
        open={showAddToGroup?.isOpen}
        disableOutsideClick={false}
        ariaLabel="Create user Modal"
        maxWidth={"md"}
      >
        <div className="modal-inner-wrapper-lg">
          <ModalTitle>
            <Title size="large">{USER_GROUP_DETAILS_CONSTANTS.MODAL_ADD_GROUP_TITLE}</Title>
          </ModalTitle>
          <div
            className="modal-close-icon-button"
            data-testid="addUsersToGroupsModal_closeIcon"
            onClick={(e) => {
              setShowAddToGroup({ isOpen: false });
              setGroupFormFields(defaultGroupFormFields);
            }}
          >
            <Icon name="close" />
          </div>
          <ModalBody>
            <div className="modal-body-full-width">
              <AddUserToGroupCommonTable
                dataList={[...notificationGroupList]}
                addToGroupId={addToGroupId}
                handleAddGroupCheckBoxChange={handleAddGroupCheckBoxChange}
                pagination={false}
                scroll={{
                  y: 210,
                }}
                className="modal-table-wrapper"
              />
            </div>
          </ModalBody>
          <ModalFooter
            buttonData={{
              primary: {
                width: "150px",
                children: USER_GROUP_DETAILS_CONSTANTS.BUTTON_ADD,
                disabled:
                  !getValidUsersIdToAddGroup() ||
                  getValidUsersIdToAddGroup()?.length <= 0 ||
                  !addToGroupId,
                "data-testid": "addUsersToGroupsModal_addButton",
                onClick: () => {
                  onAddUser();
                },
              },
            }}
          />
        </div>
      </Dialog>
    </>
  );
};

export const DeleteUserGroupModal = (props) => {
  const {
    confirmDelete,
    showDeleteUserGroupModal,
    message,
    title,
    membersCount,
    showWarningBanner,
  } = props;
  return (
    <Modal
      opened={showDeleteUserGroupModal?.isOpen}
      className="user-groups-modal"
      disableOutsideClick={true}
      hideCloseButton={true}
      closeButton={
        <div
          className="modal-close-button"
          data-testid="userGroupsModal_closeButton"
          onClick={() => confirmDelete(false)}
        >
          <Icon name="close" ariaHidden={true} />
        </div>
      }
      ariaLabel={`${title} Modal`}
      onOpenedChange={(opened) => {
        if (!opened) confirmDelete(false);
      }}
    >
      <div className="delete-group-modal-content">
        <Loader active={showDeleteUserGroupModal?.isLoading} fullscreen={false} />
        {showWarningBanner && (
          <div className="delete-group-warning">
            <div className="delete-group-warning-inner">
              <div className="delete-group-warning-header">
                <WarningIcon className="delete-group-warning-icon" />
                <span className="delete-group-warning-title">{DELETE_GROUP_MODAL_CONSTANTS.WARNING_TITLE}</span>
              </div>
              <div className="delete-group-warning-body">
                <Body size="medium" viewport="desktop" primitive="p">
                  {DELETE_GROUP_MODAL_CONSTANTS.WARNING_MESSAGE(membersCount)}
                </Body>
              </div>
            </div>
          </div>
        )}
        <div className="dialog-title-section">
          <Title size="large" bold primitive="h2" viewport="desktop">
            {title}
          </Title>
        </div>
        <div className="dialog-body-section">
          <Body size="medium" viewport="desktop" primitive="p">
            {message ?? DELETE_GROUP_MODAL_CONSTANTS.CONFIRM_MESSAGE} <strong>{showDeleteUserGroupModal?.groupName ?? showDeleteUserGroupModal?.userName}</strong>?
          </Body>
        </div>
        <div className="dialog-button-container">
          <Button
            size="medium"
            use="primary"
            className="dialog-button"
            data-testid="userGroupsModal_confirmDeleteButton"
            disabled={showDeleteUserGroupModal?.isLoading}
            onClick={() => confirmDelete(true, showDeleteUserGroupModal?.record)}
          >
            {DELETE_GROUP_MODAL_CONSTANTS.CONFIRM_BUTTON}
          </Button>
          <Button
            size="medium"
            use="secondary"
            className="dialog-button"
            data-testid="userGroupsModal_noDeleteButton"
            disabled={showDeleteUserGroupModal?.isLoading}
            onClick={() => confirmDelete(false)}
          >
            {DELETE_GROUP_MODAL_CONSTANTS.CANCEL_BUTTON}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export const DeleteInviteModal = ({ opened, onOpenedChange, selectedUser, confirmDelete }) => (
  <Dialog
    open={opened}
    onClose={() => onOpenedChange(false)}
    aria-labelledby="delete-invite-dialog-title"
    maxWidth="sm"
    fullWidth={true}
  >
    <div
      className="dialog-close-button"
      onClick={() => onOpenedChange(false)}
    >
      <Icon name="close" size="medium" />
    </div>
    <div className="dialog-content">
      <div className="dialog-title-section">
        <Title size="large" bold primitive="h2" viewport="desktop">
          {MODAL_TEXT.ARE_YOU_SURE}
        </Title>
      </div>
      <div className="dialog-body-section">
        <Body size="medium" viewport="desktop" primitive="p">
          {MODAL_TEXT.DELETE_INVITED_USER_CONFIRM}
        </Body>
      </div>
      <div className="dialog-button-container">
         <Button 
          size="medium" 
          use="primary" 
          onClick={confirmDelete}
          className="dialog-button"
        >
          {MODAL_TEXT.YES_DELETE_USER}
        </Button>
        <Button 
          size="medium" 
          use="secondary" 
          onClick={() => onOpenedChange(false)}
          className="dialog-button"
        >
          {MODAL_TEXT.CANCEL}
        </Button>
      </div>
    </div>
  </Dialog>
);

export const ResendInviteModal = ({ opened, onOpenedChange, selectedUser, confirmResend }) => (
  <Dialog
    open={opened}
    onClose={() => onOpenedChange(false)}
    aria-labelledby="resend-invite-dialog-title"
    maxWidth="sm"
    fullWidth={true}
  >
    <div
      className="dialog-close-button"
      onClick={() => onOpenedChange(false)}
    >
      <Icon name="close" size="medium" />
    </div>
    <div className="dialog-content">
      <div className="dialog-title-section">
        <Title size="large" bold primitive="h2" viewport="desktop">
          {MODAL_TEXT.RESEND_INVITE}
        </Title>
      </div>
      <div className="dialog-body-section">
        <Body size="medium" viewport="desktop" primitive="p">
          {MODAL_TEXT.RESEND_INVITE_CONFIRM} {selectedUser?.User}'s invitation?
        </Body>
      </div>
      <div className="dialog-button-container">
        <Button 
          size="medium" 
          use="primary" 
          onClick={confirmResend}
          className="dialog-button"
        >
          {MODAL_TEXT.RESEND_INVITE_BUTTON}
        </Button>
        <Button 
          size="medium" 
          use="secondary" 
          onClick={() => onOpenedChange(false)}
          className="dialog-button"
        >
          {MODAL_TEXT.CANCEL}
        </Button>
      </div>
    </div>
  </Dialog>
);
